import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { AdminItem } from '../../models/domain/admin.item';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';

export interface IMessageDialog {
    Title: string;
    Message: string;
}

@Component({
    selector: 'message-dialog',
    styleUrls: ['./message.dialog.scss'],
    templateUrl: './message.dialog.html'
})

export class MessageDialog extends DialogComponent<IMessageDialog, boolean> implements IMessageDialog, OnInit {
    IsBusy: boolean = false;
    Title: string;
    Message: string;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

    }

}
